import { render, staticRenderFns } from "./RiyVsRhpChart.vue?vue&type=template&id=036211dc&scoped=true"
import script from "./RiyVsRhpChart.vue?vue&type=script&lang=js"
export * from "./RiyVsRhpChart.vue?vue&type=script&lang=js"
import style0 from "./RiyVsRhpChart.vue?vue&type=style&index=0&id=036211dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036211dc",
  null
  
)

export default component.exports